<template>
    <div>
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;height: 100%;">
                            <p style="border-bottom: 1px solid #d6d6da;padding-bottom: 10px;">实名认证</p>
                            <sub-real-name-content url="/user-realname-result"></sub-real-name-content>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'
import SubRealNameContent from '../public/sub/SubRealNameContent.vue'

export default {
    name: 'UserRealname',
    components: {
        HdHeader,
        HdFooter,
        HdAside,
        SubRealNameContent
    },
    data () {
        return {}
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserRealname.vue